import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RolesDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8'
    })
  };

  constructor(private http: HttpClient) { }

  public getRolesList(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    return this.http.post(this.BASE_URL + 'private/v2.0/role/ws_getRoleList', item, options);
  }

  public getRoleInfo(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/role/ws_getRoleDetails', item, options);
  }

  public addNewRole(context, lang, udid, roleFatherInternalId, companyInternalId, rolename, menuOptions) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { roleFatherInternalId, companyInternalId, rolename, menuOptions };
    return this.http.post(this.BASE_URL + 'private/v2.0/role/ws_saveRole', item, options);
  }

  public updateRoleInfo(context, lang, udid, roleInternalId, companyInternalId, rolename) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { roleInternalId, companyInternalId, rolename };
    return this.http.post(this.BASE_URL + 'private/v2.0/role/ws_saveRole', item, options);
  }

  public updateRoleMenuOptions(context, lang, udid, roleInternalId, companyInternalId, menuOptions) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { roleInternalId, companyInternalId, menuOptions };
    return this.http.post(this.BASE_URL + 'private/v2.0/role/ws_saveRole', item, options);
  }

  public deleteRole(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/role/ws_deleteRole', item, options);
  }
}
